import { Suspense, use, useState, type ReactNode } from 'react'
import { RuntimeInspector } from '@w/runtime/inspector'
import { ErrorBoundary } from '@w/ui/system/error-boundary'
import { IconButton } from '@w/ui/components/icon-button'
import { BugIcon, XIcon } from '@w/ui/components/icon'

/** Diagnostics must be reachable even before the router context finishes opening. */
export function RuntimeStartup({ app }: { app: Promise<ReactNode> }) {
  return <ErrorBoundary fallback={<StartupDiagnostics failed />}>
    <Suspense fallback={<StartupDiagnostics />}><ReadyApp app={app} /></Suspense>
  </ErrorBoundary>
}

function StartupDiagnostics({ failed = false }: { failed?: boolean }) {
  const [open, setOpen] = useState(false)
  return <div className="flex h-dvh flex-col">
    <div className="flex items-center justify-between gap-2 p-4">
      <p role={failed ? 'alert' : 'status'}>{failed ? 'Flashcards could not start.' : 'Starting Flashcards…'}</p>
      <IconButton variant="text" aria-label={open ? 'Close runtime diagnostics' : 'Open runtime diagnostics'} onClick={() => { setOpen(!open) }}>
        {open ? <XIcon /> : <BugIcon />}
        {open ? 'Close runtime diagnostics' : 'Open runtime diagnostics'}
      </IconButton>
    </div>
    {open && <RuntimeInspector />}
  </div>
}

function ReadyApp({ app }: { app: Promise<ReactNode> }) { return use(app) }
